<template>
    <div style="height: 100%">
        <div class="column-layout clearfix overflow-hidden" style="height: 100%">
            <div class="left-column fl" :class="{'active' : !treeCollapse}">
                <div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">组织机构</li>
                        </ul>
                    </div>
                </div>
                <div id="tree-menu" style="overflow-y: auto;">
                    <swb-org-tree :searchSize="'mini'" :enableSearch="true" :bizDepart="true" @notity-change="notityChange($event)" @show-tree-collapse="showTreeCollapse($event)"></swb-org-tree>
                </div>
            </div>
            <div class="right-column fl" style="height: 100%; overflow: auto">
                <swb-retailer-com-role-select :comId="comId" ref="swb_retailer_com_role_select"></swb-retailer-com-role-select>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, showQrCodeImageDlg, DomSizeWatcher, Routes } from '../../app.vues'
    //
    import retailerApi from '../../api/retailer'
    import retailerAuthxApi from '../../api/retailerAuthx'
    import userApi from '../../api/user'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    import SwbRetailerComRoleForSelect from '../staffBiz/RetailerComRoleForSelect'
    Vue.regist(SwbRetailerComRoleForSelect);

    export default {
        name: 'swb-retailer-com-role-list-select',
        desc: '公司岗位选择',
        data: function () {
            return {
                refresh: false,
                itemId: null,
                comId: null,
                treeCollapse: true,
                //
                retailerComRoleList: [],
                selectRel: null,
            }
        },
        created: function () {
            //
            this.getUserInfoByContext();
        },
        methods: {
            notityChange(eventData) {
                if(this.comId != eventData.id) {
                    this.comId = eventData.id;
                }
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let userContext = result.data;
                        let scopeEntity = userContext.scopeEntity;
                        if(scopeEntity != null) {
                            self.merchantId = scopeEntity.id;
                            self.comId = scopeEntity.comId;
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },

            getDlgResult: function () {
                return this.$refs.swb_retailer_com_role_select.getDlgResult() || {};
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerComRoleSelect.vue